import { Box } from "@material-ui/core";
import React from "react";

import { Option } from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisChoiceRow } from "./DiagnosisChoiceRow";

type RankingListProps<T extends string> = {
  options: Option<T>[];
  ranked: T[];
  max: number;
  onChange: (next: T[]) => void;
};
export function DiagnosisInvestmentStyleRankingList<T extends string>({
  options,
  ranked,
  max,
  onChange,
}: RankingListProps<T>) {
  const toggle = (value: T) => {
    if (ranked.includes(value)) {
      onChange(ranked.filter((v) => v !== value));
      return;
    }
    if (ranked.length >= max) return;
    onChange([...ranked, value]);
  };
  return (
    <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
      {options.map((option) => {
        const rank = ranked.indexOf(option.value);
        return (
          <DiagnosisChoiceRow
            key={option.value}
            label={option.label}
            value={option.value}
            checked={rank >= 0}
            rank={rank + 1}
            disabled={rank < 0 && ranked.length >= max}
            onChange={() => toggle(option.value)}
          />
        );
      })}
    </Box>
  );
}
